﻿import {MonoBehaviour} from "../Utils/Unity/MonoBehaviour";
import {Reward} from "../Data/GameData";
import {Core} from "./Core";
import {di} from "@dp-instant/core";
import {TypesSocial} from "@dp-instant/interfaces";
import {isIOS} from "../../dpCommonPortHelper";

const STORAGE_PURCHASES = "homo-evolution-purchases";

const PurchasedProducts = new Map();
PurchasedProducts.toJSON = function () {
    return this.size > 0 ? [...this.entries()] : null;
};
PurchasedProducts.Load = async function () {
    // let data = await FBInstant.player.getDataAsync([STORAGE_PURCHASES]);
    const cookie = di.get(TypesSocial.cookie);
    let data = await cookie.get([STORAGE_PURCHASES]);
    let purchases = data ? data[STORAGE_PURCHASES] : null;
    if (purchases) {
        for (let [id, value] of purchases) {
            this.set(id, value);
        }
    }
};
PurchasedProducts.Save = async function () {
    const cookie = di.get(TypesSocial.cookie);

    await cookie.save(STORAGE_PURCHASES, this.size > 0 ? this : null);

    // await FBInstant.player.setDataAsync({
    //     [STORAGE_PURCHASES]: this.size > 0 ? this : null
    // });
};
PurchasedProducts.Reset = function () {
    this.clear();
    this.Save();
};

let APP_PRODUCTS = new Map();
let EMPTY_APP_PRODUCT = {
    description: "",
    imageURI: "",
    price: "$$$",
    priceAmount: 0,
    priceCurrencyCode: "XXX",
    productID: "",
    title: ""
};

class AppStoreProduct {
    id = 0;
    rewards = [];
    appProduct = {};

    #social = di.get(TypesSocial.model);

    get purchased() {
        return PurchasedProducts.get(this.id);
    }

    set purchased(val) {
        if (val) {
            PurchasedProducts.set(this.id, val);
        } else {
            PurchasedProducts.delete(this.id);
        }
        PurchasedProducts.Save();
    }

    Init(config) {
        this.id = config.id;
        this.appProduct = {...EMPTY_APP_PRODUCT, ...(APP_PRODUCTS.get(this.id) || {})};
        for (let reward of config.rewards) {
            this.rewards.push(new Reward(reward));
        }
    }

    async Purchase() {
        try {
            let purchase = await FBInstant.payments.purchaseAsync({
                productID: this.id
            });
            this.purchased = Date.now();
            await this.ConsumeRewards(purchase);

            // const result = await this.social.payments.purchase(this.id);
        } catch (e) {
            console.log("PURCHASE FAILED", e);
        }
    }

    async ConsumeRewards(purchase = null) {
        for (let reward of this.rewards) {
            reward.Take(this.id, true);
        }
        if (purchase) {
            try {
                await FBInstant.payments.consumePurchaseAsync(purchase.purchaseToken);
            } catch (e) {
                console.log("PURCHASE CONSUME ERROR", e);
            }
        }
    }

    GetPrice() {
        return this.appProduct.price;
    }

    GetPriceNumber() {
        return this.appProduct.priceAmount;
    }
}

export class AppStore extends MonoBehaviour {
    products = new Map();
    available = false;

    get purchasedProducts() {
        return PurchasedProducts;
    }

    get VipActive() {
        return !!PurchasedProducts.get("vip");
    }
    set VipActive(val) {
        PurchasedProducts.set("vip", val ? Date.now() : null);
        PurchasedProducts.Save();
    }

    get IsInitialized() {
        return this.available && this.products.size > 0;
    }

    async Init() {
        if (this.IsInitialized) return;

        PurchasedProducts.Load();

        // this.available = FBInstant.getPlatform().toUpperCase() !== "IOS";
        this.available = !isIOS() && __SOCIAL__ !== "ya"; // SHOP switch off for Yandex

        if (!this.available) return;

        try {
            //await this.social.payments.init();

            let appProducts = await FBInstant.payments.getCatalogAsync();
            //let appProducts = this.social.this.social.payments.getAll();

            if (appProducts) {
                for (let product of appProducts) {
                    APP_PRODUCTS.set(product.productID, {...product});
                }
            }
        } catch (e) {
            console.warn("AppStore error", e);
            return;
        }

        for (let config of Core.GameData.AppStore.inAppProducts) {
            let product = new AppStoreProduct();
            product.Init(config);
            this.products.set(product.id, product);
        }

        await this.ConsumeAll();
    }

    async ConsumeAll() {
        let unconsumedPurchases = await FBInstant.payments.getPurchasesAsync();
        //let unconsumedPurchases = this.social.payments.purchases;
        for (let purchase of unconsumedPurchases) {
            await this.ConsumePurchase(purchase);
        }
    }

    async ConsumePurchase(purchase) {
        let product = this.GetProduct(purchase.productID);
        if (product) {
            await product.ConsumeRewards(purchase);
        }
    }

    GetProduct(productId) {
        return this.products.get(productId);
    }

    ProductAvailable(productId, purchaseCheck = false) {
        let product = this.GetProduct(productId);
        return product && (!purchaseCheck || !product.purchased);
    }

    BuyProductID(productId) {
        let product = this.GetProduct(productId);
        if (!product) {
            console.warn("STORE: Trying to buy unknown product", productId);
            return false;
        }
        product.Purchase();
        this.emit("Purchased", product);
    }

    GetPrice(productId) {
        let product = this.GetProduct(productId);
        return product ? product.GetPrice() : EMPTY_APP_PRODUCT.price;
    }

    GetPriceNumber(productId) {
        let product = this.GetProduct(productId);
        return product ? product.GetPriceNumber() : 0;
    }

    Reset() {
        PurchasedProducts.Reset();
    }
}
